import React from 'react';

const ClubActivitys = () => {
    return <div>Activity is here....</div>;
};

export default ClubActivitys;